import * as React from 'react'

import { InfoIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import StruxhubSelect from '~/client/src/shared/components/StruxhubInputs/StruxhubSelect'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MaterialsUploadStore from '../MaterialsUpload.store'

// localization: translated

interface IProps {
  store: MaterialsUploadStore
  titleRenderer(title: string): JSX.Element
}

@observer
export default class MapMaterialsFieldsDialog extends React.Component<IProps> {
  public render() {
    const { store, titleRenderer } = this.props
    const {
      isMapFieldsDialogShown,
      resetInitialValues,
      openUploadConfigDialog,
      fields,
      columnMap,
      isMapDialogBtnEnabled,
      getSheetColumnsAsOptions,
    } = store

    return (
      <Dialog open={isMapFieldsDialogShown}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle render={<div />}>
              {titleRenderer(Localization.translator.mapFields)}
            </DialogTitle>
          </DialogHeader>
          <div className="relative">
            <div className="text large light mb20">
              {Localization.translator.uploadScheduleDescriptions.mapFields}
            </div>
            {fields.map(({ name, caption, isRequired, isFirstLocation }) => (
              <div key={name} className="col">
                {isFirstLocation && this.locationInfo}
                <div className="row">
                  <StruxhubSelect
                    name={name}
                    className="overflow-hidden"
                    label={caption}
                    isRequired={isRequired}
                    value={columnMap[name] || ''}
                    onChange={this.onSelectChanged.bind(this, name)}
                  >
                    <option value=""></option>
                    {getSheetColumnsAsOptions(name).map(opt => (
                      <option key={opt} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </StruxhubSelect>
                </div>
              </div>
            ))}
          </div>

          <DialogFooter>
            <Button
              variant="outline"
              className="tw:grow"
              onClick={resetInitialValues}
            >
              {Localization.translator.cancel}
            </Button>
            <Button
              variant="default"
              className="tw:grow"
              disabled={!isMapDialogBtnEnabled}
              onClick={openUploadConfigDialog}
            >
              {Localization.translator.next}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }

  private get locationInfo(): JSX.Element {
    return (
      <div className="tw:flex tw:items-center text small bold pl5 no-outline">
        {Localization.translator.materialsUploading.makeSureLocationNamesUnique}
        <InfoIcon className="ml5 tw:size-4" />
      </div>
    )
  }

  private onSelectChanged(
    fieldName: string,
    e: React.ChangeEvent<HTMLSelectElement>,
  ) {
    this.props.store.addColumnMap(fieldName, e.target.value)
  }
}
